import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState(0);

  const faqs = [
    {
      id: 1,
      question: 'Wie lange hält eine NANO-Versiegelung?',
      answer: `Eine professionelle NANO-Versiegelung hält bei normaler Nutzung 12-24 Monate. Die Haltbarkeit hängt von verschiedenen Faktoren ab:\n\n• Fahrzeugnutzung und Kilometerleistung\n• Witterungsbedingungen und Standort\n• Pflege und Wartung der Versiegelung\n• Qualität der verwendeten Produkte\n\nWir verwenden nur hochwertige NANO-Beschichtungen und geben Ihnen eine Garantie von 12 Monaten auf unsere Arbeit.`
    },
    {
      id: 2,
      question: 'Was kostet eine Komplettaufbereitung?',
      answer: `Die Kosten für eine Komplettaufbereitung variieren je nach Fahrzeuggröße und gewünschten Services:\n\n• Kleinwagen: ab 199€\n• Mittelklasse: ab 299€\n• SUV/Kombi: ab 399€\n• Premiumfahrzeuge: ab 499€\n\nInklusive sind: Außenreinigung, Innenraumaufbereitung, Felgenreinigung, Scheibenpflege und Grundversiegelung. Zusatzleistungen wie NANO-Versiegelung werden separat berechnet.`
    },
    {
      id: 3,
      question: 'Wie lange dauert die Aufbereitung meines Fahrzeugs?',
      answer: `Die Dauer hängt vom gewählten Service ab:\n\n• Außenhandwäsche: 1-2 Stunden\n• Innenreinigung: 2-3 Stunden\n• Premium Politur: 3-5 Stunden\n• NANO-Versiegelung: 4-6 Stunden\n• Komplettaufbereitung: 6-8 Stunden\n\nWir arbeiten gründlich und nehmen uns die nötige Zeit für perfekte Ergebnisse. Gerne können Sie Ihr Fahrzeug auch über Nacht bei uns lassen.`
    },
    {
      id: 4,
      question: 'Kann ich während der Aufbereitung warten?',
      answer: `Ja, gerne! Wir bieten verschiedene Möglichkeiten:\n\n• Komfortable Kundenlounge mit WLAN\n• Kostenlose Getränke und Zeitschriften\n• Parkplätze für Begleitfahrzeuge\n• Einkaufsmöglichkeiten in der Nähe\n\nBei längeren Services (über 4 Stunden) empfehlen wir unseren kostenlosen Hol- und Bringservice im Umkreis von 15 km.`
    },
    {
      id: 5,
      question: 'Welche Zahlungsmöglichkeiten gibt es?',
      answer: `Wir akzeptieren alle gängigen Zahlungsmethoden:\n\n• Barzahlung\n• EC-Karte (Girocard)\n• Kreditkarten (Visa, Mastercard)\n• PayPal\n• Überweisung (bei Terminbuchung)\n\nFür Firmenkunden bieten wir auch Rechnungskauf mit 14 Tagen Zahlungsziel an.`
    },
    {
      id: 6,
      question: 'Bieten Sie auch Garantie auf Ihre Arbeit?',
      answer: `Ja, wir stehen zu 100% hinter unserer Arbeit:\n\n• 6 Monate Garantie auf Außenaufbereitung\n• 12 Monate Garantie auf NANO-Versiegelung\n• 3 Monate Garantie auf Innenraumreinigung\n• 12 Monate Garantie auf Lackreparaturen\n\nSollten Sie nicht zufrieden sein, bessern wir kostenlos nach oder erstatten den vollen Betrag zurück.`
    },
    {
      id: 7,
      question: 'Kann ich online einen Termin buchen?',
      answer: `Ja, die Terminbuchung ist ganz einfach:\n\n• Online-Buchung über unsere Website\n• Telefonische Buchung: Dinslaken 02064 777722\n• WhatsApp-Buchung möglich\n• E-Mail-Anfragen werden innerhalb von 2 Stunden beantwortet\n\nWir bestätigen jeden Termin schriftlich und erinnern Sie 24 Stunden vorher.`
    },
    {
      id: 8,
      question: 'Arbeiten Sie auch bei schlechtem Wetter?',
      answer: `Ja, wir arbeiten wetterunabhängig:\n\n• Überdachte Arbeitsplätze in Dinslaken\n• Geschlossene Hallen für Premium-Services\n• Klimatisierte Räume für optimale Arbeitsbedingungen\n• Nur bei extremen Wetterbedingungen (Sturm, Hagel) verschieben wir Termine\n\nIhre Sicherheit und die Qualität unserer Arbeit haben oberste Priorität.`
    }
  ];

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? -1 : index);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6">
            <Icon name="HelpCircle" size={16} />
            <span className="text-sm font-medium">Häufige Fragen</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6">
            Fragen &
            <span className="block text-primary">Antworten</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Hier finden Sie Antworten auf die häufigsten Fragen rund um unsere Services. 
            Haben Sie weitere Fragen? Kontaktieren Sie uns gerne!
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs?.map((faq, index) => (
            <div
              key={faq?.id}
              className="bg-muted/30 rounded-xl overflow-hidden transition-all duration-300 hover:shadow-input"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-6 text-left flex items-center justify-between hover:bg-muted/50 transition-colors"
                aria-expanded={openFAQ === index}
              >
                <h3 className="text-lg font-semibold text-foreground pr-4">
                  {faq?.question}
                </h3>
                <div className={`transform transition-transform duration-300 ${
                  openFAQ === index ? 'rotate-180' : 'rotate-0'
                }`}>
                  <Icon name="ChevronDown" size={20} className="text-muted-foreground" />
                </div>
              </button>
              
              <div className={`overflow-hidden transition-all duration-300 ${
                openFAQ === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
              }`}>
                <div className="px-6 pb-6">
                  <div className="text-muted-foreground leading-relaxed whitespace-pre-line">
                    {faq?.answer}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-primary/10 to-accent/10 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-foreground mb-4">
              Weitere Fragen?
            </h3>
            <p className="text-muted-foreground mb-6">
              Unser Team steht Ihnen gerne für eine persönliche Beratung zur Verfügung.
            </p>
            <div className="flex justify-center">
              <a
                href="tel:02064 777722"
                className="inline-flex items-center space-x-2 bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary/90 transition-colors"
              >
                <Icon name="Phone" size={16} />
                <span>Dinslaken: 02064 777722</span>
              </a>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div className="mt-12 grid md:grid-cols-3 gap-6 text-center">
          <div className="p-6 bg-white rounded-xl shadow-card">
            <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="MessageCircle" size={24} className="text-accent" />
            </div>
            <h4 className="font-semibold text-foreground mb-2">WhatsApp</h4>
            <p className="text-sm text-muted-foreground mb-3">
              Schnelle Antworten per WhatsApp
            </p>
            <a
              href="https://wa.me/491636923382"
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent hover:text-accent/80 text-sm font-medium"
            >
              Nachricht senden →
            </a>
          </div>

          <div className="p-6 bg-white rounded-xl shadow-card">
            <div className="w-12 h-12 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Mail" size={24} className="text-success" />
            </div>
            <h4 className="font-semibold text-foreground mb-2">E-Mail</h4>
            <p className="text-sm text-muted-foreground mb-3">
              Detaillierte Anfragen per E-Mail
            </p>
            <a
              href="mailto:info@cleanparadise.de"
              className="text-success hover:text-success/80 text-sm font-medium"
            >
              E-Mail schreiben →
            </a>
          </div>

          <div className="p-6 bg-white rounded-xl shadow-card">
            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="MapPin" size={24} className="text-primary" />
            </div>
            <h4 className="font-semibold text-foreground mb-2">Vor Ort</h4>
            <p className="text-sm text-muted-foreground mb-3">
              Persönliche Beratung in unseren Filialen
            </p>
            <button
              onClick={() => document.getElementById('locations')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-primary hover:text-primary/80 text-sm font-medium"
            >
              Standorte anzeigen →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;